import { getUserStore } from "../store/store";
import { mutatorAction } from "satcheljs";
import type { MailboxInfo } from "owa-client-types";

export const setPriorityTableViewIdMutator: (mailboxInfo: MailboxInfo, id: string | undefined) => void = mutatorAction("setPriorityTableViewId", (mailboxInfo: MailboxInfo, id: string | undefined): void => {
    const store = getUserStore(mailboxInfo);
    if (store.priorityTableViewId !== id) {
        store.priorityTableViewId = id;
    }
});
